var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgImgProfile = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "img-profile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#C6C6C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#img-profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 9.625a5.632 5.632 0 0 0 5.625 5.625 5.632 5.632 0 0 0 5.625-5.625A5.632 5.632 0 0 0 14.25 4a5.632 5.632 0 0 0-5.625 5.625ZM24.25 27.75h1.25V26.5c0-4.824-3.926-8.75-8.75-8.75h-5C6.925 17.75 3 21.676 3 26.5v1.25h21.25Z",
    fill: "#8B8B8B"
  }))));
};
export { SvgImgProfile as ReactComponent };
export default __webpack_public_path__ + "ba6f2ab0be2b9d9764ce29dc1ce3cc9e.svg";